import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { products } from '../data/products';
export function Contact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormStatus('success');
    }, 1500);
  };
  return <div className="bg-gray-50 min-h-screen py-12 lg:py-20" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-175">
          <h1 className="text-4xl md:text-5xl font-extrabold text-yarbo-dark mb-6" data-id="element-176">
            Contact Merem Robotics About Yarbo
          </h1>
          <p className="text-lg text-gray-600" data-id="element-177">
            Request a quote, ask about local Michigan setup options, or get help
            choosing the right Yarbo system for your property.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-178">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-8" data-id="element-179">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-180">
              <h3 className="text-xl font-bold text-yarbo-dark mb-6" data-id="element-181">
                Get in Touch
              </h3>

              <div className="space-y-6" data-id="element-182">
                <div className="flex items-start" data-id="element-183">
                  <MapPin className="w-6 h-6 text-yarbo-yellow mr-4 mt-1 flex-shrink-0" data-id="element-184" />
                  <div data-id="element-185">
                    <h4 className="font-bold text-gray-900" data-id="element-186">Service Area</h4>
                    <p className="text-gray-600 mt-1" data-id="element-187">
                      [Address or Michigan Service Area Placeholder]
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-188">
                  <Phone className="w-6 h-6 text-yarbo-yellow mr-4 mt-1 flex-shrink-0" data-id="element-189" />
                  <div data-id="element-190">
                    <h4 className="font-bold text-gray-900" data-id="element-191">Phone</h4>
                    <p className="text-gray-600 mt-1" data-id="element-192">[Phone Placeholder]</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-193">
                  <Mail className="w-6 h-6 text-yarbo-yellow mr-4 mt-1 flex-shrink-0" data-id="element-194" />
                  <div data-id="element-195">
                    <h4 className="font-bold text-gray-900" data-id="element-196">Email</h4>
                    <p className="text-gray-600 mt-1" data-id="element-197">[Email Placeholder]</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-198">
                  <Clock className="w-6 h-6 text-yarbo-yellow mr-4 mt-1 flex-shrink-0" data-id="element-199" />
                  <div data-id="element-200">
                    <h4 className="font-bold text-gray-900" data-id="element-201">Business Hours</h4>
                    <p className="text-gray-600 mt-1" data-id="element-202">
                      Mon-Fri: 9am - 5pm EST
                      <br data-id="element-203" />
                      Sat-Sun: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-yarbo-charcoal p-8 rounded-2xl text-white" data-id="element-204">
              <h3 className="text-xl font-bold mb-4" data-id="element-205">Why Buy Local?</h3>
              <ul className="space-y-3 text-gray-300 text-sm" data-id="element-206">
                <li data-id="element-207">• Guidance specific to Michigan weather</li>
                <li data-id="element-208">• Help assessing your property layout</li>
                <li data-id="element-209">• Advice on docking station placement</li>
                <li data-id="element-210">• Direct line for questions and support</li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-211">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-gray-200" data-id="element-212">
              {formStatus === 'success' ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="text-center py-16" data-id="element-213">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-214">
                    <Send className="w-10 h-10 text-green-600" data-id="element-215" />
                  </div>
                  <h3 className="text-3xl font-bold text-yarbo-dark mb-4" data-id="element-216">
                    Message Sent!
                  </h3>
                  <p className="text-gray-600 text-lg mb-8" data-id="element-217">
                    Thank you for reaching out to Merem Robotics. We'll get back
                    to you shortly with your quote or answers to your questions.
                  </p>
                  <button onClick={() => setFormStatus('idle')} className="btn-secondary" data-id="element-218">
                    Send Another Message
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-219">
                  <h3 className="text-2xl font-bold text-yarbo-dark mb-6 border-b border-gray-100 pb-4" data-id="element-220">
                    Request My Yarbo Quote
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-221">
                    <div data-id="element-222">
                      <label htmlFor="name" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-223">
                        Full Name *
                      </label>
                      <input type="text" id="name" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all" placeholder="John Doe" data-id="element-224" />
                    </div>
                    <div data-id="element-225">
                      <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-226">
                        Email Address *
                      </label>
                      <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all" placeholder="john@example.com" data-id="element-227" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-228">
                    <div data-id="element-229">
                      <label htmlFor="phone" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-230">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all" placeholder="(555) 123-4567" data-id="element-231" />
                    </div>
                    <div data-id="element-232">
                      <label htmlFor="city" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-233">
                        Michigan City/Zip *
                      </label>
                      <input type="text" id="city" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all" placeholder="Traverse City, 49684" data-id="element-234" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-235">
                    <div data-id="element-236">
                      <label htmlFor="interest" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-237">
                        Product Interest
                      </label>
                      <select id="interest" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all bg-white" data-id="element-238">
                        <option value="" data-id="element-239">Select a product...</option>
                        <option value="not-sure" data-id="element-240">
                          Not sure yet - Need advice
                        </option>
                        {products.filter(p => p.category !== 'Accessories').map(p => <option key={p.id} value={p.id} data-id="element-241">
                              {p.name}
                            </option>)}
                      </select>
                    </div>
                    <div data-id="element-242">
                      <label htmlFor="propertySize" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-243">
                        Property Size
                      </label>
                      <select id="propertySize" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all bg-white" data-id="element-244">
                        <option value="" data-id="element-245">Select size...</option>
                        <option value="under-0.5" data-id="element-246">Under 0.5 Acre</option>
                        <option value="0.5-1" data-id="element-247">0.5 - 1 Acre</option>
                        <option value="1-3" data-id="element-248">1 - 3 Acres</option>
                        <option value="3-6" data-id="element-249">3 - 6 Acres</option>
                        <option value="over-6" data-id="element-250">Over 6 Acres</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-251">
                    <label htmlFor="message" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-252">
                      Message / Questions
                    </label>
                    <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your property, specific challenges (steep hills, long driveway), or ask about demo availability..." data-id="element-253"></textarea>
                  </div>

                  <button type="submit" disabled={formStatus === 'submitting'} className="btn-primary w-full py-4 text-lg flex justify-center items-center" data-id="element-254">
                    {formStatus === 'submitting' ? <span className="flex items-center" data-id="element-255">
                        Sending...{' '}
                        <motion.div animate={{
                    rotate: 360
                  }} transition={{
                    repeat: Infinity,
                    duration: 1,
                    ease: 'linear'
                  }} className="ml-2 w-5 h-5 border-2 border-yarbo-dark border-t-transparent rounded-full" data-id="element-256" />
                      </span> : <span className="flex items-center" data-id="element-257">
                        Submit Request <Send className="ml-2 w-5 h-5" data-id="element-258" />
                      </span>}
                  </button>
                  <p className="text-xs text-gray-500 text-center mt-4" data-id="element-259">
                    By submitting this form, you agree to be contacted by Merem
                    Robotics regarding Yarbo products.
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}